/*
 * File: Tag.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 4, 2022 at 4:30 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 2:18 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Styles
import * as S from './Tag.styles';


/**
 * Component
 */

export const Tag = ({
	className, children, size, isActive, ...rest
}) => {

	// Handle actions on component load
	useEffect(() => {}, []);

	// Render component
	return (
		<S.Wrapper
			className={className ? `${className} animate${isActive ? ' active' : ''}` : `animate${isActive ? ' active' : ''}`}
			$size={size}
			{...rest}
		>
			{children}
		</S.Wrapper>
	);
};


/**
 * Configuration
 */

Tag.displayName = 'Tag';
Tag.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
	isActive: PropTypes.bool,
	size: PropTypes.oneOf(['compact', 'normal'])
};
Tag.defaultProps = {
	className: null,
	children: null,
	isActive: false,
	size: 'normal'
};
